<template>
  <!-- 页面容器 -->
  <div class="news-detail-container">
    <!-- 导航栏 -->
    <van-nav-bar
      title="公告明细"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />

    <!-- 内容区域 -->
    <div class="content-wrapper" v-if="!loading">
      <!-- 新闻标题 -->
      <!-- <h1 class="news-title">{{ newsData.name }}</h1> -->
      <!-- 正文内容 -->
      <div class="news-content">
        <div class="content-text" v-html=" newsData.content "></div>
      </div>
    </div>

    <!-- 加载状态 -->
    <van-loading v-else size="24px" vertical>加载中...</van-loading>

  </div>
</template>
<script>
import { getNewsDetail } from '@/api/Index/index'
export default {
  name: 'Article',
  props: {
    // 视频ID
    Id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      newsData: {
        title: '标题加载中...',
        source: '新闻来源',
        publishTime: '2023-08-20 10:00',
        content: '<p>新闻正文内容...</p>'
      },
      videoInfo: {},
      relatedNews: [
        { id: 1, title: '相关新闻标题1', source: '来源1', time: '08-20 09:00' },
        { id: 2, title: '相关新闻标题2', source: '来源2', time: '08-20 08:30' }
      ],
      commentCount: 15
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      // 模拟API请求
      const { data: res } = await getNewsDetail(this.Id)
      this.loading = false
      this.newsData = res
      console.log(this.newsData)
    },
    handleRelatedClick(id) {
      // 处理相关新闻点击
      console.log('查看相关新闻:', id)
    }
  }
}
</script>

<style scoped>
/* 整体容器 */
.news-detail-container {
  min-height: 100vh;
  background: #f8f9fa;
  padding-bottom: 68px;
}

/* 导航栏优化 */
.van-nav-bar {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
}

.van-nav-bar__text {
  color: #666 !important;
}

/* 新闻标题 */
.news-title {
  font-size: 24px;
  line-height: 1.35;
  margin: 20px 16px 12px;
  color: #1a1a1a;
  font-weight: 700;
  letter-spacing: -0.3px;
}

/* 元信息 */
.meta-info {
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-bottom: 20px;
  color: #999;
  font-size: 13px;
}

.van-divider {
  margin: 0 8px;
  background-color: #ddd;
}

.source {
  color: #1677ff;
  font-weight: 500;
}

.time {
  font-size: 12px;
}

/* 正文内容 */
.news-content {
  padding: 0 16px;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 24px;
}

.content-image {
  width: 100%;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease;
}

.content-image:active {
  transform: scale(0.98);
}

.content-text {
  margin: 16px 0;
}

.content-text ::v-deep p {
  margin: 1em 0;
  text-align: justify;
}

/* 相关新闻 */
.section-title {
  position: relative;
  padding: 16px;
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  background: #fff;
}

.section-title::before {
  content: "";
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background: #1677ff;
  border-radius: 2px;
}

.related-item {
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s ease;
}

.related-item:active {
  background: #f8f8f8;
}

.related-title {
  font-size: 15px;
  color: #333;
  line-height: 1.4;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.related-meta {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-size: 12px;
}

/* 加载状态 */
.van-loading {
  padding-top: 100px;
}

/* 底部操作栏优化 */
.action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 68px;
  background: rgba(255, 255, 255, 0.96);
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.van-icon {
  font-size: 22px;
  color: #666;
  transition: all 0.2s ease;
  padding: 8px;
  border-radius: 50%;
}

.van-icon:active {
  background: rgba(0, 0, 0, 0.05);
  transform: scale(0.92);
}

.van-icon[name="star-o"] {
  color: #ffc439;
}

.van-icon[name="good-job-o"] {
  color: #fe2d55;
}

/* 优化间距和点击反馈 */
[class*="van-hairline"]::after {
  border-color: #f0f0f0 !important;
}
</style>
